// extracted by mini-css-extract-plugin
export default {"container":"GZdzilKkzhMP2TUPqni1","voiceProfiles":"VGrTWwFCfZi9NI0T7VCz","tooltip":"CIqrTvtG8hFjhcPxfnCv"};